import { render, staticRenderFns } from "./SoldApplianceList.vue?vue&type=template&id=d81e0d44&scoped=true"
import script from "./SoldApplianceList.vue?vue&type=script&lang=js"
export * from "./SoldApplianceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d81e0d44",
  null
  
)

export default component.exports